/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

'use strict';

/**
 * A directive that directly handles the restrictions being utilized in the organization settings page.
 */

angular.module('bulbApp.organizationModule')
.directive('restrictionsTable', restrictionsTable);

function restrictionsTable() {
  return {
    scope: {
      topOrg: '<',
      currentRestrictedOrg: '=',
      defaultRestrictions: '<'
    },
    templateUrl: 'ajs/organization/organization-restrictions.html',
    controller: 'OrganizationRestrictionsController as organizationRestrictionsCtrl'
  };
}
